export default __webpack_public_path__ + "static/media/project7.f4285185.png";